import React from "react";
import { FormattedMessage } from "react-intl";
import EmailInput, {
  type IEmailProps,
} from "src/shared/forms/inputs/EmailInput";

export interface IContactEmailInputProps extends IEmailProps {}

export default ({
  label = <FormattedMessage id="contacts.email" />,
  ...rest
}: IContactEmailInputProps) => (
  <EmailInput {...rest} label={label} isRequired={false} maxLength={128} />
);
